import * as React from "react";

const CENDropDownIcon: React.FC = () => {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.3051 2.54453L6.83674 7.04453C6.58713 7.26602 6.29885 7.375 6.01057 7.375C5.72229 7.375 5.43471 7.26514 5.21498 7.04541L0.746626 2.54541C0.39346 2.22461 0.297118 1.73945 0.471282 1.32109C0.645446 0.902734 1.056 0.625 1.51057 0.625H10.4789C10.9339 0.625 11.3445 0.898551 11.5189 1.31934C11.6932 1.74012 11.6285 2.22461 11.3051 2.54453Z"
                fill="#262525"
            />
        </svg>
    );
};

export default React.memo(CENDropDownIcon);
